export const getters = {
  PREV_ROUTE: (state) => state.prevRoute,
}
